
import {
  Component, PropSync, Prop, Ref, Mixins,
} from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import { emailShipment } from '@/features/shipment-history/services/shipment-history.services';
import { showErrorAlertDialog, showSuccessAlertDialog } from '@/features/common/helpers';
import { VForm } from '@/features/common/types';
import { emailRules, requiredRules } from '@/features/common/helpers/validationRules';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class Notification extends Mixins(focusMixin) {
  @Ref('form') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) secureshipTrackingNo!: string;

  @Prop({ required: false, default: false }) qrCodeMode!: boolean;

  private isEmailLoading = false;

  private emailAddress = '';

  private requiredRules = requiredRules;

  private emailRules: InputValidationRules = [
    ...this.requiredRules,
    ...emailRules,
  ]

  private submit() {
    const isValid = this.form.validate();
    if (!isValid) return;
    this.emailLabel();
  }

  private async emailLabel() {
    this.isEmailLoading = true;
    const response = await emailShipment(
      this.secureshipTrackingNo,
      this.emailAddress,
      this.qrCodeMode,
    );

    if (response.successful) {
      showSuccessAlertDialog(this.$t('printShipment.emailSuccessMessage', {
        email: this.emailAddress,
      }) as string);

      this.syncedShow = false;
    } else {
      showErrorAlertDialog();
    }
    this.isEmailLoading = false;
  }
}
